/**
 * 结算流水状态(S-09)。**单点定义在这里,三端引用。**
 *
 * 取值与 docs/openapi.yaml 的 Settlement.status、prisma 的 SettlementStatus 逐字一致,
 * 漂移会在 apps/api/src/common/enum-parity.ts 变成编译错误。
 *
 *   pending   两段式结算的中间态(付款即建流水、完成再定金额)。
 *             **本期不走两段**:流水建在订单完成那一刻,那时钱与费率都已经确定
 *   payable   应付承运商。**本期唯一的初始状态**
 *   paid_out  平台真的把钱打给承运商了。本期没有打款通道(线下对公转账),没有路径产出
 *   reversed  冲正。取消与退款(S-08)那条链路才会写它
 *
 * 后三个里有两个本期**没有任何路径会产出它们**。写在这里而不是留给人去发现,
 * 理由同 PAYMENT_STATUS 里的 failed:「刻意从不出现」与「本该出现但漏了」
 * 在数据里长得一模一样(ESC-004 记的就是这个机制)。
 */
export const SETTLEMENT_STATUS = ['pending', 'payable', 'paid_out', 'reversed'] as const

export type SettlementStatus = (typeof SETTLEMENT_STATUS)[number]

export function isSettlementStatus(x: unknown): x is SettlementStatus {
  return typeof x === 'string' && (SETTLEMENT_STATUS as readonly string[]).includes(x)
}
